// @flow
import {PRODUCT} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

/**
 * Reducer for no readers power error
 * @param {boolean} state Current state
 * @param {ActionType<boolean>} action Received action
 * @returns {boolean} state New state
 */
export default function isNoReadersPowerError(
    state: boolean = false,
    action: ActionType<boolean>,
): boolean {
    switch (action.type) {
        case PRODUCT.SET_NO_READERS_POWER_ERROR:
            return action.payload;
        default:
            return state;
    }
}
